(() => {
  if (window.xteinkGiftStickyCartInitialized) return;
  window.xteinkGiftStickyCartInitialized = true;

  // The app's sticky button normally sends its own device-only cart request.
  // Capture clicks before the app handles them and submit the theme form so
  // gift selection, scheduling, paid add-ons and cart rendering share one path.
  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest?.('#bundle-sticky_submit');
    if (!stickyButton) return;

    const productForm = document.querySelector(
      'product-info[id^="MainProduct-"] product-form'
    );
    if (!productForm?.form || !productForm.submitButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = productForm.submitButton;
    // Variant changes disable the main button until the new variant is ready.
    // Also block repeated clicks while the shared cart request is in flight.
    if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    // Call the shared handler directly: app submit interception must not prevent
    // the sticky button from reaching the theme's multi-item cart request.
    productForm.onSubmitHandler(event);
  }, true);
})();
